/* ============================================================
   HealthyHeads PDP — behaviour
   Scoped to each .hh-pdp[data-hh-pdp] root so it can't clash with
   Woofy or run twice. No jQuery. No global side effects except the
   Woofy cart-drawer trigger (reused from the existing buy box).
   ============================================================ */
(function () {
  "use strict";

  function initRoot(root) {
    if (root.dataset.hhInit === "1") return;
    root.dataset.hhInit = "1";

    var currency = root.dataset.currency || "EUR";
    var moneyFmt;
    try {
      moneyFmt = new Intl.NumberFormat("nl-NL", { style: "currency", currency: currency });
    } catch (e) {
      moneyFmt = { format: function (cents) { return "€ " + (cents / 100).toFixed(2).replace(".", ","); } };
    }
    var money = function (cents) { return moneyFmt.format((cents || 0) / 100); };

    // ---- element refs ----
    var mainVariantId = root.dataset.mainVariant ? parseInt(root.dataset.mainVariant, 10) : null;
    var mainAvailable = root.dataset.mainAvailable === "true";

    var bundleCards = Array.prototype.slice.call(root.querySelectorAll("[data-hh-bundle]"));
    var sizeCards = Array.prototype.slice.call(root.querySelectorAll("[data-hh-size]"));
    var doseValue = root.querySelector("[data-hh-dose-value]");

    var upsell = root.querySelector("[data-hh-upsell]");
    var upsellToggle = root.querySelector("[data-hh-upsell-toggle]");
    var upsellVariantId = upsell && upsell.dataset.upsellVariant ? parseInt(upsell.dataset.upsellVariant, 10) : null;
    var upsellPriceCents = upsell ? parseInt(upsell.dataset.upsellPrice || "0", 10) : 0;
    var upsellAvailable = upsell ? upsell.dataset.upsellAvailable === "true" : false;

    var atcBtn = root.querySelector("[data-hh-atc]");
    var atcPriceEl = root.querySelector("[data-hh-atc-price]");
    var atcCompareEl = root.querySelector("[data-hh-atc-compare]");
    var atcLabelEl = root.querySelector("[data-hh-atc-label]");
    var errorEl = root.querySelector("[data-hh-error]");
    var ATC_LABEL = atcLabelEl ? atcLabelEl.textContent.trim() : "In winkelwagen";

    // Optional mirror button in mobile sticky bar
    var stickyBtn = document.querySelector('[data-hh-atc-jump][data-for="' + root.id + '"]');
    var stickyPriceEl = null;

    // ---- state ----
    var selected = { qty: 1, priceCents: 0, compareCents: 0 };
    var busy = false;

    // ---- helpers ----
    function activeBundle() { return root.querySelector("[data-hh-bundle].is-active"); }

    function readBundle(card) {
      selected.qty = parseInt(card.dataset.qty || "1", 10);
      selected.priceCents = parseInt(card.dataset.priceCents || "0", 10);
      selected.compareCents = parseInt(card.dataset.compareCents || "0", 10);
    }

    function totalCents() {
      var t = selected.priceCents;
      if (upsellToggle && upsellToggle.checked && upsellAvailable) t += upsellPriceCents;
      return t;
    }
    function totalCompareCents() {
      // Only show a struck-through compare when there is a real saving.
      var base = selected.compareCents || 0;
      if (base <= 0) return 0;
      var c = base;
      if (upsellToggle && upsellToggle.checked && upsellAvailable) c += upsellPriceCents;
      return c;
    }

    function renderPrice() {
      var total = totalCents();
      var compare = totalCompareCents();
      if (atcPriceEl) atcPriceEl.textContent = money(total);
      if (stickyPriceEl) stickyPriceEl.textContent = money(total);
      if (atcCompareEl) {
        if (compare > total) { atcCompareEl.textContent = money(compare); atcCompareEl.style.display = ""; }
        else { atcCompareEl.style.display = "none"; }
      }
    }

    function setUnavailableUI() {
      if (!atcBtn) return;
      if (!mainVariantId || !mainAvailable) {
        atcBtn.disabled = true;
        if (atcLabelEl) atcLabelEl.textContent = "Uitverkocht";
        if (stickyBtn) stickyBtn.classList.add("is-disabled");
      } else {
        atcBtn.disabled = false;
        if (atcLabelEl) atcLabelEl.textContent = ATC_LABEL;
        if (stickyBtn) stickyBtn.classList.remove("is-disabled");
      }
    }

    function selectBundle(card) {
      bundleCards.forEach(function (c) {
        c.classList.remove("is-active");
        var r = c.querySelector('input[type="radio"]'); if (r) r.checked = false;
      });
      card.classList.add("is-active");
      var radio = card.querySelector('input[type="radio"]'); if (radio) radio.checked = true;
      readBundle(card);
      renderPrice();
    }

    // ---- bundles ----
    bundleCards.forEach(function (card) {
      card.addEventListener("click", function () { selectBundle(card); });
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); selectBundle(card); }
      });
    });

    // ---- size selector (UI + dosering + auto-selects the mapped bundle) ----
    var doseHint = root.querySelector("[data-hh-dose-hint]");
    var sizeNotes = Array.prototype.slice.call(root.querySelectorAll("[data-hh-size-note]"));

    // Doorverwijsregel van de actieve maat tonen, de rest verbergen.
    function toonMaatNotitie(card) {
      if (!sizeNotes.length) return;
      var idx = card ? card.getAttribute("data-note") : null;
      sizeNotes.forEach(function (n) {
        n.hidden = n.getAttribute("data-hh-size-note") !== idx;
      });
    }

    sizeCards.forEach(function (card) {
      card.addEventListener("click", function () {
        sizeCards.forEach(function (c) { c.classList.remove("is-active"); c.setAttribute("aria-selected", "false"); });
        card.classList.add("is-active");
        card.setAttribute("aria-selected", "true");

        // Heeft deze maat geen dosering (bv. een tegel die naar een ander
        // product verwijst), dan verdwijnt de doseringsregel in plaats van
        // die van de vorige maat te laten staan.
        if (card.dataset.dose) {
          if (doseValue) doseValue.textContent = card.dataset.dose;
          if (doseHint) doseHint.hidden = false;
        } else if (doseHint) {
          doseHint.hidden = true;
        }

        toonMaatNotitie(card);

        zetMeestGekozen(card);

        // auto-select the bundle this size maps to (e.g. Klein->1, Middelgroot->2, Groot->3)
        var q = card.dataset.selectQty;
        if (q) {
          var target = bundleCards.filter(function (b) { return b.dataset.qty === q; })[0];
          if (target) selectBundle(target);
        }
        if (root.hhUpdatePerDay) root.hhUpdatePerDay();
      });
    });

    // 'Meest gekozen' per gewichtsklasse. Heeft de gewichtsknop een aantal
    // ingevuld, dan staat de badge op de tegel met dat aantal potten; anders
    // terug naar de tegel die in het bundelblok is uitgelicht.
    function zetMeestGekozen(size) {
      // alleen in de stand 'Prijs per dag'; de oude tegels blijven zoals ze zijn
      if (!root.classList.contains("hh-pdp--rw")) return;
      var q = size && size.dataset.popularQty;
      bundleCards.forEach(function (b) {
        var aan = q ? b.dataset.qty === q : b.dataset.hhDefaultTop === "1";
        b.classList.toggle("has-top", aan);
      });
    }
    zetMeestGekozen(root.querySelector("[data-hh-size].is-active"));

    // Beginstand: doseringsregel verbergen als de actieve maat er geen heeft.
    var startSize = root.querySelector("[data-hh-size].is-active");
    if (startSize && !startSize.dataset.dose && doseHint) doseHint.hidden = true;

    // ---- upsell toggle (whole card is a click target) ----
    if (upsell && upsellToggle) {
      if (!upsellAvailable) { upsell.classList.add("is-unavailable"); upsellToggle.disabled = true; }
      upsellToggle.addEventListener("change", function () {
        upsell.classList.toggle("is-active", upsellToggle.checked);
        renderPrice();
      });
    }

    // ---- Woofy cart drawer (reused from existing hh-buy-box logic) ----
    function openWoofyDrawer() {
      var trigger = document.querySelector(".openCartDrawer, .cart-icon");
      if (trigger) { trigger.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true })); return true; }
      var drawer = document.getElementById("mini__cart") || document.querySelector(".yv_side_drawer_wrapper.mini_cart");
      if (drawer) { document.body.classList.add("side_Drawer_open"); return true; }
      return false;
    }

    function showError(msg) {
      if (!errorEl) { alert(msg); return; }
      errorEl.textContent = msg;
      errorEl.classList.add("is-visible");
      setTimeout(function () { errorEl.classList.remove("is-visible"); }, 5000);
    }

    // ---- add to cart ----
    function addToCart() {
      if (busy) return;
      if (!mainVariantId || !mainAvailable) return;
      busy = true;
      if (errorEl) errorEl.classList.remove("is-visible");

      var buttons = [atcBtn].filter(Boolean);
      buttons.forEach(function (b) { b.disabled = true; b.classList.add("is-loading"); });
      var prevLabel = atcLabelEl ? atcLabelEl.textContent : "";
      if (atcLabelEl) atcLabelEl.textContent = "Toevoegen…";

      // verborgen line item property: gekozen hondgrootte -> Shopify order + Klaviyo
      var sizeBtn = root.querySelector("[data-hh-size].is-active") || root.querySelector("[data-hh-size]");
      var sizeLabel = sizeBtn ? (sizeBtn.getAttribute("data-size-label") || "").trim() : "";
      var mainItem = { id: mainVariantId, quantity: selected.qty };
      if (sizeLabel) { mainItem.properties = { "_Hondgrootte": sizeLabel }; }

      var items = [mainItem];
      if (upsellToggle && upsellToggle.checked && upsellAvailable && upsellVariantId) {
        items.push({ id: upsellVariantId, quantity: 1 });
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json", "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || "Toevoegen mislukt");
            return data;
          });
        })
        .then(function () {
          if (typeof window.refreshCart === "function") { try { window.refreshCart(); } catch (e) {} }
          document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
          if (!openWoofyDrawer()) window.location.href = "/cart";
        })
        .catch(function (err) {
          console.error("[hh-pdp] add to cart", err);
          showError("Er ging iets mis bij het toevoegen. Probeer het opnieuw.");
        })
        .finally(function () {
          busy = false;
          buttons.forEach(function (b) { b.disabled = false; b.classList.remove("is-loading"); });
          if (atcLabelEl) atcLabelEl.textContent = prevLabel || ATC_LABEL;
          setUnavailableUI();
          renderPrice();
        });
    }
    if (atcBtn) atcBtn.addEventListener("click", addToCart);
    // sticky knop = ankerlink: soepel naar de potten-selector scrollen
    if (stickyBtn) {
      stickyBtn.addEventListener("click", function (e) {
        var target = root.querySelector(".hh-pdp__bundles");
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({ top: y, behavior: "smooth" });
        target.classList.add("hh-pdp__bundles--flash");
        window.setTimeout(function () { target.classList.remove("hh-pdp__bundles--flash"); }, 1200);
      });
    }

    // ---- gallery ----
    var galleryMain = root.querySelector(".hh-pdp__gallery-main");
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-hh-slide]"));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-hh-thumb]"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hh-dot]"));
    var prevBtn = root.querySelector("[data-hh-prev]");
    var nextBtn = root.querySelector("[data-hh-next]");
    var galleryIndex = 0;

    function updateNav() {
      var last = slides.length - 1;
      if (prevBtn) prevBtn.hidden = galleryIndex <= 0;   // no "back" on the first image
      if (nextBtn) nextBtn.hidden = galleryIndex >= last; // no "next" on the last image
    }

    function goToSlide(i) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(i, slides.length - 1)); // clamp — no wrap-around
      galleryIndex = i;
      slides.forEach(function (s, si) { s.classList.toggle("is-active", si === i); });
      thumbs.forEach(function (t, ti) { t.classList.toggle("is-active", ti === i); });
      dots.forEach(function (d, di) { d.classList.toggle("is-active", di === i); });
      updateNav();
      speelVideo();
    }

    // Video's: alleen de zichtbare speelt, de rest pauzeert. Een YouTube/Vimeo-
    // video kan het script niet starten of stoppen; die bedient de bezoeker zelf.
    var autoplay = root.dataset.hhVideoAutoplay !== "0";
    function speelVideo() {
      slides.forEach(function (s, si) {
        var v = s.querySelector("video");
        if (!v) return;
        if (si === galleryIndex && autoplay) {
          v.muted = true;
          v.setAttribute("muted", "");
          v.setAttribute("playsinline", "");
          var start = function () {
            var p = v.play();
            if (p && p.catch) p.catch(function () {}); // browser weigert: knop blijft staan
          };
          // nog niet geladen: starten zodra er genoeg binnen is
          if (v.readyState >= 2) start();
          else v.addEventListener("canplay", start, { once: true });
        } else {
          v.pause();
        }
      });
    }

    thumbs.forEach(function (thumb, i) { thumb.addEventListener("click", function () { goToSlide(i); }); });
    dots.forEach(function (dot, i) { dot.addEventListener("click", function () { goToSlide(i); }); });
    if (prevBtn) prevBtn.addEventListener("click", function () { goToSlide(galleryIndex - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goToSlide(galleryIndex + 1); });

    // touch swipe (mobile)
    if (galleryMain && slides.length > 1) {
      var touchX = null, touchY = null;
      galleryMain.addEventListener("touchstart", function (e) {
        touchX = e.touches[0].clientX; touchY = e.touches[0].clientY;
      }, { passive: true });
      galleryMain.addEventListener("touchend", function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goToSlide(galleryIndex + (dx < 0 ? 1 : -1));
        }
        touchX = null; touchY = null;
      }, { passive: true });
    }

    updateNav(); // set correct arrow state on load (starts on first image)
    speelVideo();

    // ---- mobile sticky bar visibility (show once buy box scrolls out of view) ----
    var stickyBar = document.querySelector('[data-hh-sticky-bar][data-for="' + root.id + '"]');
    var stickyAnchor = root.querySelector(".hh-pdp__features") || atcBtn;
    if (stickyBar && "IntersectionObserver" in window && stickyAnchor) {
      document.documentElement.classList.add("hh-pdp--has-sticky");
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (window.innerWidth >= 900) { stickyBar.classList.remove("is-visible"); return; }
          // alleen tonen als de buy-box BOVEN het scherm is (dus voorbij gescrold),
          // niet wanneer die nog onder de vouw ligt
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          stickyBar.classList.toggle("is-visible", scrolledPast);
        });
      }, { threshold: 0 });
      io.observe(stickyAnchor);
    }

    // ---- prijs per dag meebewegen met hondgrootte ----
    var bundlesWrap = root.querySelector(".hh-pdp__bundles");
    function hhUpdatePerDay() {
      if (!bundlesWrap) return;
      var perPot = parseInt(bundlesWrap.getAttribute("data-chews-per-pot"), 10) || 60;
      var activeSize = root.querySelector("[data-hh-size].is-active");
      var cpd = activeSize ? parseInt(activeSize.getAttribute("data-chews"), 10) : 1;
      if (!cpd || cpd < 1) cpd = 1;
      Array.prototype.forEach.call(root.querySelectorAll("[data-hh-bundle]"), function (card) {
        var span = card.querySelector(".hh-pdp__bundle-sub .hh-pdp__book");
        if (!span) return;
        var cents = parseInt(card.getAttribute("data-price-cents"), 10);
        var qty = parseInt(card.getAttribute("data-qty"), 10) || 1;
        if (!cents) return;
        var perDay = Math.floor((cents / (qty * perPot)) * cpd);
        span.textContent = "€" + (perDay / 100).toFixed(2).replace(".", ",") + " per dag";
      });
    }
    root.hhUpdatePerDay = hhUpdatePerDay;
    hhUpdatePerDay();

    /* ----------------------------------------------------------
       Buy box variant B — looptijd per bundel + kuurmelding.
       Draait alleen wanneer de sectie op 'v2' staat; op alle
       bestaande pagina's wordt dit blok overgeslagen.
       ---------------------------------------------------------- */
    if (root.classList.contains("hh-pdp--bbv2") && bundlesWrap) {
      var kuurDays = parseInt(root.dataset.hhKuurDays, 10) || 60;
      var kuurEl = root.querySelector("[data-hh-kuur]");
      // Zonder maatselector is er geen dagdosering, dus valt er ook
      // geen looptijd te berekenen. De regel verdwijnt dan helemaal
      // in plaats van een verzonnen getal te tonen.
      var heeftMaten = !!root.querySelector("[data-hh-size]");

      function chewsPerDay() {
        var s = root.querySelector("[data-hh-size].is-active") || root.querySelector("[data-hh-size]");
        var n = s ? parseInt(s.getAttribute("data-chews"), 10) : 1;
        return n && n > 0 ? n : 1;
      }
      function chewsPerPot() {
        return parseInt(bundlesWrap.getAttribute("data-chews-per-pot"), 10) || 60;
      }
      function daysFor(qty) {
        return Math.round((chewsPerPot() * qty) / chewsPerDay());
      }
      // Hele maanden waar het uitkomt, anders afronden op weken.
      // Hele maanden waar het precies uitkomt. Daarboven afronden op
      // maanden naar beneden, zodat we nooit meer beloven dan de
      // verpakking levert. Korter dan twee maanden leest in weken.
      function looptijd(d) {
        if (d % 30 === 0) {
          var m = d / 30;
          return m === 1 ? "1 maand" : m + " maanden";
        }
        if (d >= 60) {
          return "circa " + Math.floor(d / 30) + " maanden";
        }
        var w = Math.round(d / 7);
        return "circa " + w + (w === 1 ? " week" : " weken");
      }
      // Eenheid komt uit de theme editor: pot, fles, zak, wat past.
      var eenheidEen = root.dataset.hhUnitOne || "pot";
      var eenheidMeer = root.dataset.hhUnitMany || "potten";
      function potLabel(q) { return q + " " + (q === 1 ? eenheidEen : eenheidMeer); }

      function bundlesByQty() {
        return bundleCards
          .map(function (c) { return { card: c, qty: parseInt(c.dataset.qty || "1", 10) }; })
          .sort(function (a, b) { return a.qty - b.qty; });
      }
      // Kleinste bundel die de hele kuur dekt.
      function advisedQty() {
        var list = bundlesByQty();
        for (var i = 0; i < list.length; i++) {
          if (daysFor(list[i].qty) >= kuurDays) return list[i].qty;
        }
        return list.length ? list[list.length - 1].qty : 1;
      }

      function esc(s) {
        return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      }
      function renderKuur() {
        if (!kuurEl) return;
        var tpl = kuurEl.getAttribute("data-kuur-tpl") || "";
        var sizeEl = root.querySelector("[data-hh-size].is-active") || root.querySelector("[data-hh-size]");
        var adj = sizeEl ? (sizeEl.getAttribute("data-adjective") || "") : "";
        var qty = advisedQty();
        var out = esc(tpl)
          .replace(/\[maat\]/g, esc(adj))
          .replace(/\[ww\]/g, qty === 1 ? "is" : "zijn")
          .replace(/\[potten\]/g, potLabel(qty));
        // Tekst tussen |pipes| wordt vet. Zonder pipes verandert er niets.
        var stukken = out.split("|");
        out = stukken.map(function (deel, i) {
          return i % 2 === 1 ? "<strong>" + deel + "</strong>" : deel;
        }).join("");
        // Dubbele spatie als [maat] leeg is
        kuurEl.innerHTML = out.replace(/\s{2,}/g, " ");
      }

      function renderSupply() {
        bundleCards.forEach(function (card) {
          var qty = parseInt(card.dataset.qty || "1", 10);
          var d = daysFor(qty);
          var txt = "Genoeg voor " + looptijd(d);
          Array.prototype.forEach.call(card.querySelectorAll("[data-hh-supply]"), function (el) {
            el.textContent = txt;
            el.classList.toggle("is-enough", d >= kuurDays);
          });
        });
      }

      function verbergLooptijd() {
        bundleCards.forEach(function (card) {
          Array.prototype.forEach.call(card.querySelectorAll("[data-hh-supply]"), function (el) {
            var rij = el.closest ? el.closest("li") : null;
            (rij || el).style.display = "none";
          });
        });
      }

      /* ---------- tegels met voordelen ----------
         De tegel heet dan "X dagen voorraad", de prijs staat per dag, en
         onderin zie je wat deze bundel oplevert. Elk voordeel heeft zijn
         eigen drempel, dus of het slotje open is volgt uit de prijs. */
      var tegelStand = bundlesWrap.getAttribute("data-tile-mode") || "detail";
      var drempelShip = parseInt(bundlesWrap.getAttribute("data-ship-threshold"), 10);
      var drempelGift = parseInt(bundlesWrap.getAttribute("data-gift-threshold"), 10);
      if (isNaN(drempelShip)) drempelShip = 4900;
      if (isNaN(drempelGift)) drempelGift = 4900;

      var lbSupply = bundlesWrap.getAttribute("data-supply-label") || "dagen voorraad";
      var lbVrij = bundlesWrap.getAttribute("data-state-free") || "";
      var lbSlot = bundlesWrap.getAttribute("data-state-locked") || "";
      var giftNaam = bundlesWrap.getAttribute("data-gift-name") || "";
      var giftWaarde = bundlesWrap.getAttribute("data-gift-value") || "";
      var stripShip = bundlesWrap.getAttribute("data-strip-ship") || "";
      var stripGift = bundlesWrap.getAttribute("data-strip-gift") || "";
      var stripBeide = bundlesWrap.getAttribute("data-strip-both") || "";

      var VINK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      var SLOT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

      function vulSjabloon(t) {
        return (t || "").replace(/\[cadeau\]/g, giftNaam).replace(/\[waarde\]/g, giftWaarde);
      }

      // €70,00 wordt €70; bedragen met centen blijven zoals ze zijn
      function heleEuro(c) {
        var t = money(c);
        return c % 100 === 0 ? t.replace(/[,.]00(?=\D*$)/, "") : t;
      }

      function centen(card, attr) {
        var v = parseInt(card.getAttribute(attr), 10);
        return isNaN(v) ? 0 : v;
      }

      function renderTegels() {
        bundleCards.forEach(function (card) {
          var qty = parseInt(card.dataset.qty || "1", 10);
          var prijs = centen(card, "data-price-cents");
          var vanaf = centen(card, "data-compare-cents");
          var dagen = heeftMaten ? daysFor(qty) : 0;

          // naam wordt de looptijd, maar alleen als die te berekenen is
          var naamEl = card.querySelector("[data-hh-bname]");
          if (naamEl && dagen > 0) naamEl.textContent = dagen + " " + lbSupply;

          // prijs per dag
          var perEl = card.querySelector("[data-hh-perday]");
          var noteEl = card.querySelector("[data-hh-perday-note]");
          var cmpEl = card.querySelector("[data-hh-perday-compare]");
          if (perEl && dagen > 0) {
            perEl.textContent = money(Math.round(prijs / dagen));
            if (noteEl) noteEl.hidden = false;
            if (cmpEl) {
              if (vanaf > prijs) {
                cmpEl.textContent = money(Math.round(vanaf / dagen));
                cmpEl.hidden = false;
              } else {
                cmpEl.hidden = true;
              }
            }
          } else if (noteEl) {
            noteEl.hidden = true;
          }

          var shipVrij = prijs >= drempelShip;
          var giftVrij = prijs >= drempelGift;
          var gekozen = card.classList.contains("is-active");

          // Voordelenblok alleen als deze bundel ook echt iets oplevert.
          // Een tegel die onder beide drempels blijft, blijft gewoon leeg.
          var ietsVrij = shipVrij || giftVrij;
          var blok = card.querySelector("[data-hh-rewards]");
          if (blok) {
            blok.hidden = !gekozen || !ietsVrij;
            Array.prototype.forEach.call(blok.querySelectorAll("[data-hh-reward]"), function (rw) {
              var vrij = rw.getAttribute("data-hh-reward") === "ship" ? shipVrij : giftVrij;
              rw.classList.toggle("is-locked", !vrij);
              var st = rw.querySelector("[data-hh-reward-state]");
              if (!st) return;
              // Bij het cadeau zetten we de waarde erbij, doorgestreept.
              var waarde = rw.getAttribute("data-hh-reward") === "gift" && giftWaarde
                ? "<s>" + giftWaarde + "</s>" : "";
              // Vergrendeld: laat zien vanaf welk bedrag het voordeel geldt.
              var drempel = rw.getAttribute("data-hh-reward") === "ship" ? drempelShip : drempelGift;
              var slotTekst = (lbSlot || "Vanaf [drempel]").replace(/\[drempel\]/g, heleEuro(drempel));
              st.innerHTML = vrij
                ? waarde + VINK + "<span>" + lbVrij + "</span>"
                : SLOT + "<span>" + slotTekst + "</span>";
            });
          }

          // strook: alleen op de niet-gekozen tegels, en alleen als er iets vrij is
          var strip = card.querySelector("[data-hh-bstrip]");
          if (strip) {
            var tekst = "";
            if (shipVrij && giftVrij) tekst = vulSjabloon(stripBeide);
            else if (shipVrij) tekst = vulSjabloon(stripShip);
            else if (giftVrij) tekst = vulSjabloon(stripGift);
            var CADEAU = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M3 12h18M12 8v13"/><path d="M12 8S9.5 3 7.5 4.5 9 8 12 8zm0 0s2.5-5 4.5-3.5S15 8 12 8z"/></svg>';
            strip.innerHTML = tekst ? CADEAU + "<span>" + tekst + "</span>" : "";
            strip.hidden = gekozen || tekst === "";
          }
        });
      }

      // Vervangt de v1-hook, zodat elke maatwissel beide blokken bijwerkt.
      root.hhUpdatePerDay = function () {
        if (tegelStand === "rewards") renderTegels();
        if (!heeftMaten) return;
        renderSupply();
        renderKuur();
      };

      if (heeftMaten) {
        root.hhUpdatePerDay();
      } else {
        verbergLooptijd();
        if (tegelStand === "rewards") renderTegels();
      }

      // Ook bijwerken zodra je een andere bundel kiest, want dan verhuist
      // het voordelenblok naar die tegel.
      bundleCards.forEach(function (card) {
        card.addEventListener("click", function () {
          if (tegelStand === "rewards") window.setTimeout(renderTegels, 0);
        });
      });
    }

    // ---- init ----
    var pre = activeBundle() || bundleCards[0];
    if (pre) selectBundle(pre);
    setUnavailableUI();
    renderPrice();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll("[data-hh-pdp]")).forEach(initRoot);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Re-init inside Shopify theme editor when the section is re-rendered
  document.addEventListener("shopify:section:load", function (e) {
    var r = e.target.querySelector("[data-hh-pdp]");
    if (r) { r.dataset.hhInit = ""; initRoot(r); }
  });
})();

// ---- bezorg-countdown (globaal, werkt voor buy-box + sticky bar) ----
(function () {
  var months = ["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"];
  var days = ["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"];
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  function tickAll() {
    var els = document.querySelectorAll("[data-hh-ship]");
    if (!els.length) return;
    var now = new Date();
    Array.prototype.forEach.call(els, function (el) {
      var txt = el.querySelector("[data-hh-ship-txt]");
      if (!txt) return;
      var cutoffH = parseInt(el.getAttribute("data-cutoff") || "23", 10);
      var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffH, 0, 0, 0);
      var deliv = new Date(now);
      if (now < cutoff) {
        deliv.setDate(deliv.getDate() + 1);
      } else {
        cutoff.setDate(cutoff.getDate() + 1);
        deliv.setDate(deliv.getDate() + 2);
      }
      if (deliv.getDay() === 0) deliv.setDate(deliv.getDate() + 1); // geen zondagbezorging
      var diff = cutoff - now;
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var tomorrow = new Date(now); tomorrow.setDate(tomorrow.getDate() + 1);
      var isTom = deliv.toDateString() === tomorrow.toDateString();
      var dlabel = (isTom ? "morgen " : days[deliv.getDay()] + " ") + deliv.getDate() + " " + months[deliv.getMonth()];
      var tpl = el.getAttribute("data-template") || "Bestel binnen {tijd} en ontvang je pakket {datum}";
      var timeHtml = '<strong class="hh-pdp__ship-time">' + h + "u " + pad(m) + "m " + pad(s) + "s</strong>";
      var dateHtml = "<strong>" + dlabel + "</strong>";
      txt.innerHTML = tpl.replace(/\{tijd\}/gi, timeHtml).replace(/\{datum\}/gi, dateHtml);
    });
  }
  function start() { tickAll(); setInterval(tickAll, 1000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();

/* ============================================================
   Paginabrede widgets: accordions, ingrediënten-CTA, fanclub,
   reviews-carousel. Deze staan in losse secties, dus initialiseren
   we ze document-breed (en opnieuw bij shopify:section:load).
   ============================================================ */
(function () {
  function initWidgets(scope) {
    if (!scope) return;
    // ---- accordions & FAQ ----
    Array.prototype.slice.call(scope.querySelectorAll("[data-hh-acc]")).forEach(function (acc) {
      var head = acc.querySelector("[data-hh-acc-head]");
      var body = acc.querySelector("[data-hh-acc-body]");
      if (!head || !body) return;
      head.addEventListener("click", function () {
        var open = acc.classList.toggle("is-open");
        head.setAttribute("aria-expanded", open ? "true" : "false");
        body.style.maxHeight = open ? body.scrollHeight + "px" : "0px";
      });
    });

    // ---- "Bekijk alle ingrediënten" -> scroll to hero accordions + open ingrediënten ----
    var ingCta = scope.querySelector("[data-hh-ing-cta]");
    if (ingCta) {
      ingCta.addEventListener("click", function (e) {
        var target = document.getElementById("hh-hero-accordions");
        if (!target) return; // fall back to default anchor jump
        e.preventDefault();
        var accs = Array.prototype.slice.call(target.querySelectorAll("[data-hh-acc]"));
        var pick = null;
        accs.forEach(function (acc) {
          var h = acc.querySelector("[data-hh-acc-head] span");
          if (!pick && h && /ingredi/i.test(h.textContent || "")) pick = acc;
        });
        if (!pick && accs.length) pick = accs[0];
        if (pick && !pick.classList.contains("is-open")) {
          var h = pick.querySelector("[data-hh-acc-head]");
          if (h) h.click();
        }
        target.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }

    // ---- fanclub: 1,5 rij tonen + uitklapknop ----
    var fanBox = scope.querySelector("[data-hh-fan]");
    var fanCtaWrap = scope.querySelector("[data-hh-fan-cta-wrap]");
    var fanToggle = scope.querySelector("[data-hh-fan-toggle]");
    if (fanBox && fanCtaWrap && fanToggle) {
      var fanGrid = fanBox.querySelector("[data-hh-fan-grid]");
      var fanOpen = false;
      function fanCollapsedH() {
        var first = fanGrid && fanGrid.firstElementChild;
        if (!first) return 0;
        var h = first.getBoundingClientRect().height;
        var gap = parseFloat(window.getComputedStyle(fanGrid).rowGap) || 12;
        return Math.round(h + gap + h * 0.5); // 1 volle rij + halve tweede rij
      }
      function fanApply() {
        var collapsed = fanCollapsedH();
        var full = fanGrid ? fanGrid.scrollHeight : 0;
        if (!collapsed || full <= collapsed + 4) {
          fanBox.style.maxHeight = "";
          fanBox.classList.add("is-open");
          fanCtaWrap.hidden = true;
          return;
        }
        fanCtaWrap.hidden = false;
        if (fanOpen) {
          fanBox.style.maxHeight = full + "px";
          fanBox.classList.add("is-open");
          fanToggle.textContent = fanToggle.getAttribute("data-less") || "Toon minder";
        } else {
          fanBox.style.maxHeight = collapsed + "px";
          fanBox.classList.remove("is-open");
          fanToggle.textContent = fanToggle.getAttribute("data-more") || "Bekijk meer blije klanten";
        }
      }
      fanToggle.addEventListener("click", function () {
        fanOpen = !fanOpen;
        fanApply();
        if (!fanOpen) fanBox.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      window.addEventListener("resize", fanApply);
      window.addEventListener("load", fanApply);
      Array.prototype.forEach.call(fanBox.querySelectorAll("img"), function (im) {
        if (!im.complete) im.addEventListener("load", fanApply);
      });
      fanApply();
    }

    // ---- reviews carousel (arrows + swipe + active card) ----
    var revTrack = scope.querySelector("[data-hh-rev-track]");
    if (revTrack) {
      var revPrev = scope.querySelector("[data-hh-rev-prev]");
      var revNext = scope.querySelector("[data-hh-rev-next]");
      var revCards = Array.prototype.slice.call(revTrack.querySelectorAll(".hh-pdp__review"));
      function revStep() {
        if (revCards.length > 1) return revCards[1].getBoundingClientRect().left - revCards[0].getBoundingClientRect().left;
        return revTrack.clientWidth;
      }
      function revUpdate() {
        var left = revTrack.getBoundingClientRect().left;
        var best = null, bestD = Infinity;
        revCards.forEach(function (card) {
          var d = Math.abs(card.getBoundingClientRect().left - left);
          if (d < bestD) { bestD = d; best = card; }
        });
        revCards.forEach(function (c) { c.classList.toggle("is-active", c === best); });
        if (revPrev) revPrev.disabled = revTrack.scrollLeft <= 2;
        if (revNext) revNext.disabled = revTrack.scrollLeft + revTrack.clientWidth >= revTrack.scrollWidth - 2;
      }
      if (revPrev) revPrev.addEventListener("click", function () { revTrack.scrollBy({ left: -revStep(), behavior: "smooth" }); });
      if (revNext) revNext.addEventListener("click", function () { revTrack.scrollBy({ left: revStep(), behavior: "smooth" }); });
      var revRAF;
      revTrack.addEventListener("scroll", function () { window.cancelAnimationFrame(revRAF); revRAF = window.requestAnimationFrame(revUpdate); });
      window.addEventListener("resize", function () { window.cancelAnimationFrame(revRAF); revRAF = window.requestAnimationFrame(revUpdate); });
      revUpdate();
    }

  }

  function bootWidgets() {
    Array.prototype.slice.call(document.querySelectorAll(".hh-pdp")).forEach(function (el) {
      if (el.getAttribute("data-hh-widgets") === "1") return;
      el.setAttribute("data-hh-widgets", "1");
      initWidgets(el);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootWidgets);
  else bootWidgets();
  document.addEventListener("shopify:section:load", function (e) {
    Array.prototype.slice.call(e.target.querySelectorAll(".hh-pdp")).forEach(function (el) {
      el.setAttribute("data-hh-widgets", "1");
      initWidgets(el);
    });
  });

  /* ---- aftelstrook in de sticky balk ----
     Telt af naar de ingestelde datum en verbergt zichzelf zodra die
     voorbij is. Daarmee stopt de actie vanzelf, zonder dat iemand op de
     dag zelf een vinkje hoeft om te zetten. */
  (function initAftellen() {
    var strook = document.querySelector("[data-hh-count]");
    if (!strook) return;

    var klok = strook.querySelector("[data-hh-count-clock]");
    var tot = Date.parse((strook.getAttribute("data-until") || "").replace(" ", "T"));
    if (!klok || isNaN(tot)) return;

    function tik() {
      var over = tot - Date.now();
      if (over <= 0) {
        strook.hidden = true;
        clearInterval(timer);
        return;
      }
      var sec = Math.floor(over / 1000);
      var d = Math.floor(sec / 86400);
      var u = Math.floor((sec % 86400) / 3600);
      var m = Math.floor((sec % 3600) / 60);
      var twee = function (n) { return n < 10 ? "0" + n : "" + n; };

      // Onder de dag laten we de seconden zien, want dan telt het echt af.
      klok.innerHTML = d > 0
        ? "<b>" + d + "</b>d <b>" + twee(u) + "</b>u <b>" + twee(m) + "</b>m"
        : "<b>" + twee(u) + "</b>u <b>" + twee(m) + "</b>m <b>" + twee(sec % 60) + "</b>s";

      strook.hidden = false;
    }

    tik();
    var timer = setInterval(tik, 1000);
  })();

})();
/* ============================================================
   Klantvideo's onder de FAQ: thumbnails openen een lightbox.
   Eén <video> in de lightbox; de bron wisselt per klantvideo.
   ============================================================ */
(function () {
  function bind(lb) {
    if (!lb || lb.dataset.hhKvInit === "1") return;
    lb.dataset.hhKvInit = "1";
    var root = document.getElementById(lb.getAttribute("data-for"));
    if (!root) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-hh-kv-card]"));
    if (!cards.length) return;

    // buiten de sectie hangen, zodat geen ouder met transform of overflow hem afknipt
    if (lb.parentNode !== document.body) document.body.appendChild(lb);

    var video = lb.querySelector("[data-hh-kv-video]");
    var cap = lb.querySelector("[data-hh-kv-cap]");
    var count = lb.querySelector("[data-hh-kv-count]");
    var prev = lb.querySelector("[data-hh-kv-prev]");
    var next = lb.querySelector("[data-hh-kv-next]");
    var cur = 0, opener = null, oudeOverflow = "";

    if (cards.length < 2) { prev.hidden = true; next.hidden = true; }

    function show(i) {
      cur = (i + cards.length) % cards.length;
      var c = cards[cur];
      video.pause();
      video.src = c.getAttribute("data-src");
      video.muted = false;
      var p = video.play();
      // geen geluid toegestaan: dan gedempt starten, de bezoeker zet het zelf aan
      if (p && p.catch) p.catch(function () { video.muted = true; video.play().catch(function () {}); });
      cap.textContent = c.getAttribute("data-title") || "";
      cap.hidden = !cap.textContent;
      count.textContent = cards.length > 1 ? (cur + 1) + " van " + cards.length : "";
    }
    function open(i, from) {
      opener = from;
      oudeOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = "hidden";
      lb.hidden = false;
      requestAnimationFrame(function () { lb.classList.add("is-open"); });
      show(i);
      var x = lb.querySelector("[data-hh-kv-close]"); if (x) x.focus();
    }
    function close() {
      lb.classList.remove("is-open");
      video.pause();
      video.removeAttribute("src");
      video.load();
      document.documentElement.style.overflow = oudeOverflow;
      setTimeout(function () { lb.hidden = true; if (opener) opener.focus(); }, 200);
    }

    cards.forEach(function (c, i) { c.addEventListener("click", function () { open(i, c); }); });
    lb.querySelector("[data-hh-kv-close]").addEventListener("click", close);
    prev.addEventListener("click", function () { show(cur - 1); });
    next.addEventListener("click", function () { show(cur + 1); });
    lb.addEventListener("click", function (e) {
      if (e.target === lb || e.target.hasAttribute("data-hh-kv-stage")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft" && cards.length > 1) show(cur - 1);
      else if (e.key === "ArrowRight" && cards.length > 1) show(cur + 1);
    });
    var tx = null;
    lb.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (tx === null || cards.length < 2) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
      tx = null;
    }, { passive: true });
  }

  function bootKv(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll("[data-hh-kv-lb]"), bind);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { bootKv(); });
  else bootKv();

  // theme editor: sectie opnieuw getekend → oude lightbox opruimen en opnieuw koppelen
  document.addEventListener("shopify:section:load", function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) {
      Array.prototype.forEach.call(document.querySelectorAll('body > [data-hh-kv-lb]'), function (el) {
        if (el.id === "hh-kv-lb-" + id && !e.target.contains(el)) el.parentNode.removeChild(el);
      });
    }
    bootKv(e.target);
  });
})();